import { Component, inject, effect } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TypographyComponent, BadgeComponent, TagComponent, ButtonComponent, BreadcrumbComponent, TabBarComponent, TabComponent } from '@hyperkit'
import { OverviewTabComponent, QueryLogicTabComponent } from './components'
import { HuntContextService } from '../../../services/hunt-context.service'

@Component({
  selector: 'package-details-default-view',
  imports: [CommonModule, TabBarComponent, TabComponent, OverviewTabComponent, QueryLogicTabComponent],
  templateUrl: './default-view.component.html',
  styleUrl: './default-view.component.scss',
})
export class DefaultViewComponent {
    readonly hunt = inject(HuntContextService);
    readonly huntQueryLogic = this.hunt.editor.getQueryTables;

    constructor() {
      effect(() => {
        // console.log('>>>>>>hunt', this.hunt.state.hunt())
        // console.log('Active Hunt: ', this.hunt.query.activeHunt())
      });
    }
}
